import { ServiceItemType, USABLE_SERVICE_ITEMS } from './service-items.entity';

export function isServiceItemUsable(serviceItemType: ServiceItemType): boolean {
  return USABLE_SERVICE_ITEMS.includes(serviceItemType);
}

export function getServiceItemDialog(serviceItemType: ServiceItemType): any {
  if(['customization_case', 'items_case'].includes(serviceItemType)) {
    return async () => import('./dialogs/case/case.dialog');
  } else if(['item_pack', 'sticker_pack'].includes(serviceItemType)) {
    return async () => import('./dialogs/item-pack/item-pack.dialog');
  } else if('random_item' === serviceItemType) {
    return async () => import('./dialogs/random-item/random-item.dialog');
  } else if('secret_code' === serviceItemType) {
    return async () => import('./dialogs/secret-code/secret-code.dialog');
  } else if('wager_money' === serviceItemType) {
    return async () => import('./dialogs/wager-money/wager-money.dialog');
  }

  return null;
}